import { render, staticRenderFns } from "./GroupedInstrumentsTable.vue?vue&type=template&id=2549a54a"
import script from "./GroupedInstrumentsTable.vue?vue&type=script&lang=ts"
export * from "./GroupedInstrumentsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports